export default __webpack_public_path__ + "static/media/laundry2-afterB.4f0f61e2.jpg";